<template>
    <v-list class="mention-bar">
        <div class="mention-bar__progress d-flex justify-center align-center py-6" v-if="isLoading">
            <v-progress-circular indeterminate :size="25" :width="3"></v-progress-circular>
        </div>
        <v-list-item 
            v-else-if="attendees.length"
            v-for="user in attendees" 
            :key="user.user_id" 
            @click="handleClick(user)"
        >
            <div class="d-flex align-center ma-2">
                <Avatar size="40" :avatar="user.user_logo"/>
                <div class="d-flex flex-column ml-3">
                    <span :class="{'mention-bar__user-name': true, 'mb-1': !!user.second_profile_row}">
                        {{ user.visible_username }}
                    </span>
                    <span v-if="!!user.second_profile_row" class="mention-bar__user-company">
                        {{ user.second_profile_row }}
                    </span>
                </div>
            </div>
        </v-list-item>
        <p v-else class="d-flex justify-center" style="font-size: 16px;">
            No matching users
        </p>
    </v-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Avatar from '@/components/Avatar.vue'

const DEBOUNCE_TIMEOUT = 500

export default {
    components: {
        Avatar
    },
    props: {
        searchString: {
            type: String,
            default: ''
        },
        mentions: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        ...mapActions('event', ['getAttendeesEvent', 'clearAttendeesEvent']),

        handleClick(user) {
            this.$emit('setMention', user, this.currentMention - 1)
        }
    },
    computed: {
        ...mapGetters('event', ['isLoading', 'attendees']),

        allMentions() {
            return this.searchString.split('@')
        },
        currentMention() {
            return this.mentions.length + 1
        }
    },
    watch: {
        'allMentions': {
            handler(newValue, oldValue) {
                if (newValue[this.currentMention] !== oldValue[this.currentMention]) {
                    clearTimeout(this.timer)
                    this.timer = setTimeout(() => {
                        this.getAttendeesEvent(`page=${1}&search=${this.allMentions[this.currentMention]}`)
                    }, DEBOUNCE_TIMEOUT)
                }
            },
        }
    },
    created() {
        this.getAttendeesEvent(`page=${1}`)
    },
    beforeDestroy() {
        this.clearAttendeesEvent()
    }
}
</script>

<style lang="scss">
.mention-bar {
    position: absolute;
    bottom: calc(100% + 20px);
    left: -16px;
    width: calc(100% + 32px) !important;
    max-height: 210px;
    overflow: hidden;
    border-radius: 10px 10px 0 0 !important;
    padding: 16px 8px 6px 8px;
    border-bottom: 1px solid #E2E2E2 !important;

    @media (max-width: 768px) {
        max-width: none !important;
        overflow: auto;
    }

    &__user {
        &-name {
            font-size: 14px;
            font-weight: 700;
            color: var(--accent-color);
            line-height: 22px;
        }

        &-company {
            font-size: 13px;
            color: #697583;
            line-height: 19px;
        }
    }
}
</style>